// import React from 'react'
import "./productdetail.scss";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Carousel from "react-bootstrap/Carousel";
import ProgressBar from "react-bootstrap/ProgressBar";
import Pagination from "react-bootstrap/Pagination";
import Dropdown from "react-bootstrap/Dropdown";
import { Nav } from "react-bootstrap";
import React, { useState } from "react";

import { Link } from "react-router-dom";

const Product = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [activeTab, setActiveTab] = useState("link-1");
  const handleSelect = (eventKey) => {
    setActiveTab(eventKey);
  };
  const images = [
    {
      original: "/product/dasktop.svg",
      thumbnail: "/product/dasktop.svg",
    },
    {
      original: "/product/laptop1.svg",
      thumbnail: "/product/laptop1.svg",
    },
    {
      original: "/product/three.svg",
      thumbnail: "/product/three.svg",
    },
    {
      original: "/product/applem2.svg",
      thumbnail: "/product/applem2.svg",
    },
  ];

  return (
    <div className="content">
      <section className="productdetails">
        {/* <div className='mainheadingproduct'>
                        <div className='inner'>
                            <p className='innerproductpaara'>Home</p>
                            <img src='' alt='img' className='img-fluid'/>
                        </div>
                        <div className='inner'>
                            <p className='innerproductpaara'>Electronics</p>
                            <img src='' alt='img' className='img-fluid'/>
                        </div>
                        <div className='inner'>
                            <p className='innerproductpaara'>Home Office</p>
                            <img src='' alt='img' className='img-fluid'/>
                        </div>
                        <div className='inner'>
                            <p className='innerproductpaara'>Laptops & Computers</p>
                            <img src='' alt='img' className='img-fluid'/>
                        </div>
                        <div className='inner'>
                            <p className='innerproductpaara11'>Apple 2023 MacBook Pro Laptop M2 Pro</p>
                        
                        </div>
                  
                    </div> */}
        <div className="parentsboxes">
          <div className="left">
            <div className="image-gallery-container">
              <ImageGallery items={images} />
            </div>
          </div>
          <div className="formobile d-none">
            <Carousel fade>
              <Carousel.Item>
                <Carousel.Caption>
                  <img
                    src="\product\pinklaptop.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Carousel.Caption>
                  <img
                    src="/product/laptop1.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Carousel.Caption>
                  <img
                    src="/product/applem2.svg"
                    alt="img"
                    className="img-fluid"
                  />
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>

          <div className="right">
            <div className="applebox">
              <div className="parentss">
                <div className="leftzzzz">
                  <Link to="/user/editproduct">
                    <p>Apple 2023 MacBook Pro Laptop M2 Pro</p>
                  </Link>
                </div>
                <div className="rightzzzzz"></div>
              </div>
              <div className="contentss">
                <p className="para">
                  Product Code: #AP6945
                  <span className="statussss">
                    Status: <span className="vyyyyy">Approved</span>
                  </span>{" "}
                  <span className="star">
                    <img
                      src="\product\stars.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    (34 Comments)
                  </span>
                </p>
              </div>
              <div className="newaddd">
                <p className="cateeep subp">
                  Category: <span className="kitp">Electronics</span>
                </p>
                <p className="subp">
                  Sub Category:{" "}
                  <span className="kitpp">
                    Kitchen Appliances
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M15 10.625H5C4.65833 10.625 4.375 10.3417 4.375 10C4.375 9.65833 4.65833 9.375 5 9.375H15C15.3417 9.375 15.625 9.65833 15.625 10C15.625 10.3417 15.3417 10.625 15 10.625Z"
                        fill="#007FFF"
                      />
                      <path
                        d="M10 15.625C9.65833 15.625 9.375 15.3417 9.375 15V5C9.375 4.65833 9.65833 4.375 10 4.375C10.3417 4.375 10.625 4.65833 10.625 5V15C10.625 15.3417 10.3417 15.625 10 15.625Z"
                        fill="#007FFF"
                      />
                    </svg>
                  </span>
                </p>
              </div>
            </div>
            <div className="specificationsbox">
              <h3>Specifications</h3>
              <div className="specificationinner">
                <div className="parentzzzz">
                  <h6>Colors</h6>
                  <p>Space Gray</p>
                </div>
                <div className="parentzzzz">
                  <h6>Brand</h6>
                  <p>Apple</p>
                </div>
                <div className="parentzzzz">
                  <h6>Model Name</h6>
                  <p>MacBook Pro</p>
                </div>
                <div className="parentzzzz">
                  <h6>Screen Size</h6>
                  <p>16.2 Inches</p>
                </div>
                <div className="parentzzzz">
                  <h6>CPU Model</h6>
                  <p>Apple M2 Pro Chip</p>
                </div>
                <div className="parentzzzz">
                  <h6>Ram</h6>
                  <p>32 GB</p>
                </div>
                <div className="parentzzzz">
                  <h6>Hard Disk</h6>
                  <p>1TB SSD</p>
                </div>
                <div className="parentzzzz">
                  <h6>Operating System</h6>
                  <p>Mac OS</p>
                </div>
                <div className="parentzzzz">
                  <h6>Graphics Card Description</h6>
                  <p>Integrated</p>
                </div>
                <div className="parentzzzz">
                  <h6>Special Feature</h6>
                  <p>
                    Anti Glare Coating <span>Light Weight</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="mainsssparents">
              <div className="mainssss">
                <Nav
                  variant="pills"
                  activeKey={activeTab}
                  onSelect={handleSelect}
                >
                  <Nav.Item>
                    <Nav.Link eventKey="link-1">
                      {" "}
                      <span className="productspan">Product</span> Description
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="link-2">Ratings</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="link-3">Comments</Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              {activeTab === "link-1" && (
                <>
                  <div className="maincontentinner">
                    <div className="mainimage">
                      <img
                        src="\product\blackcarrd.svg"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="mainpara">
                      <p className="parazzz">
                        All MacBook Pro models feature a brilliant Liquid Retina
                        XDR display with 20 percent brighter SDR content, a
                        built-in 1080p camera, an immersive six-speaker sound
                        system, and a wide array of connectivity options. With
                        up to 22 hours of battery life,1 the lineup offers the
                        ultimate in pro portability, delivering the same
                        performance whether plugged in or on battery, so users
                        can take their workflows anywhere. Customers can order
                        the new MacBook Pro starting today, with availability
                        beginning November 7.
                      </p>
                      <p className="parazzz">
                        “There is nothing quite like MacBook Pro. With the
                        remarkable power-efficient performance of Apple silicon,
                        up to 22 hours of battery life, a stunning Liquid Retina
                        XDR display, and advanced connectivity, MacBook Pro
                        empowers users to do their life’s best work,” said John
                        Ternus, Apple’s senior vice president of Hardware
                        Engineering. “With the next generation of M3 chips,
                        we’re raising the bar yet again for what a pro laptop
                        can do. We’re excited to bring MacBook Pro and its
                        best-in-class capabilities to the broadest set of users
                        yet, and for those upgrading from an Intel-based MacBook
                        Pro, it’s a game-changing experience in every way.”
                      </p>
                    </div>
                    <div className="mainimage">
                      <img
                        src="\product\mancard.svg"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="families">
                      <h3 className="mainhead">The M3 Family Arrives</h3>
                      <p className="parazzz">
                        The M3 family of chips continues Apple silicon’s
                        tremendous pace of innovation. M3, M3 Pro, and M3 Max
                        are the first chips for a personal computer built using
                        the industry-leading 3-nanometer technology. With a
                        faster, more efficient next-generation GPU, these chips
                        deliver the biggest leap forward in graphics
                        architecture ever for Apple silicon. Featuring a
                        breakthrough technology called Dynamic Caching, the GPU
                        allocates the use of local memory in hardware in real
                        time so only the exact amount of memory needed is used
                        for each task. This dramatically increases GPU
                        utilization and performance for the most demanding pro
                        apps and games.
                      </p>
                      <p className="parazzz">
                        The GPU also brings new rendering features to Apple
                        silicon, including hardware-accelerated mesh shading for
                        greater capability and efficiency with geometry
                        processing, enabling more visually complex scenes. And
                        hardware-accelerated ray tracing comes to the Mac for
                        the first time, enabling games to render more accurate
                        shadows and reflections to create more realistic
                        environments.
                      </p>
                    </div>
                    <div className="mainimage">
                      <img
                        src="\product\sreeens.svg"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="families">
                      <h3 className="mainhead">14-inch MacBook Pro with M3</h3>
                      <p className="parazzz">
                        For users pursuing their passions — from students and
                        business owners to aspiring musicians and video editors
                        — MacBook Pro with M3 is the ideal laptop. The 14‑inch
                        MacBook Pro with M3 is up to 60 percent faster than the
                        13‑inch MacBook Pro with M1, and with its advanced
                        thermal system, it unleashes the full potential of M3
                        for sustained performance.2 Starting at $1,599, it
                        delivers more performance and capabilities than ever at
                        a great value.
                      </p>
                      <h3 className="mainhead">With MacBook Pro with M3:</h3>
                      <ul>
                        <li>
                          Render performance in Final Cut Pro is up to 7.4x
                          faster than the 13-inch MacBook Pro with Core i7,3 and
                          up to 60 percent faster than the 13‑inch MacBook Pro
                          with M1.
                        </li>
                        <li>
                          Code compilation in Xcode is up to 3.7x faster than
                          the 13-inch MacBook Pro with Core i7,3 and up to 40
                          percent faster than the 13‑inch MacBook Pro with M1.
                        </li>
                        <li>
                          Spreadsheet performance in Microsoft Excel is up to
                          3.5x faster than the 13‑inch MacBook Pro with Core
                          i7,3 and up to 40 percent faster than the 13‑inch
                          MacBook Pro with M1.
                        </li>
                      </ul>
                    </div>
                    <div className="mainimage">
                      <img
                        src="\product\women.svg"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="families">
                      <h3 className="mainhead">Now Available in Space Black</h3>
                      <p className="parazzz">
                        MacBook Pro models with M3 Pro and M3 Max are available
                        in space black, a stunning new color that’s unmistakably
                        pro. The finish features a breakthrough chemistry that
                        forms an anodization seal to greatly reduce
                        fingerprints. M3 Pro and M3 Max models are also
                        available in silver, and the 14‑inch MacBook Pro with M3
                        is available in silver and space gray.
                      </p>
                    </div>
                    <div className="mainimage">
                      <img
                        src="\product\grey.svg"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="families">
                      <h3 className="mainhead">A Game Changer for Upgraders</h3>
                      <p className="parazzz">
                        {" "}
                        The new MacBook Pro is a big upgrade for any user,
                        especially those who have not upgraded from an
                        Intel-based Mac. The M3 Max model is up to 11x faster
                        than the fastest Intel-based MacBook Pro model.5 With
                        the power efficiency of Apple silicon, for the vast
                        majority of workloads, users will never hear the fans.
                        Battery life also soars with up to 11 additional hours
                        compared to the fastest Intel-based MacBook Pro model,5
                        and unlike many PC laptops, MacBook Pro delivers the
                        same incredible performance whether plugged in or on
                        battery. The Liquid Retina XDR display is the world’s
                        best laptop display, with an exceptional 1000 nits
                        sustained and 1600 nits of peak brightness for HDR
                        content, impressive contrast ratio, vivid colors, and an
                        outstanding viewing angle. SDR content is now displayed
                        at up to 600 nits, which is 20 percent brighter than
                        before.
                      </p>
                    </div>
                    <div className="mainimage">
                      <img
                        src="\product\pink.png"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="families">
                      <h3 className="mainhead">macOS Sonoma</h3>
                      <p className="parazzz">
                        macOS Sonoma brings a rich set of features to the Mac
                        for work and play. Users can now place widgets right on
                        the desktop, interact with them with just a click, and
                        access the extensive ecosystem of iPhone widgets on
                        their Mac through the magic of Continuity. Video
                        conferencing is even more engaging with features to help
                        users present remotely, including Presenter Overlay,
                        which places the presenter on top of the content being
                        shared; and Reactions, which enable fun
                        gesture-triggered video effects in cinematic quality. In
                        Safari, Profiles keeps browsing separate between
                        multiple topics or projects, and web apps provide faster
                        access to favorite sites. And a collection of stunning
                        new screen savers features slow-motion videos of
                        locations around the world.
                      </p>
                      <p className="parazzz">
                        macOS Sonoma also takes full advantage of the
                        capabilities of Apple silicon, offering powerful new
                        features for pros. The new high performance mode in
                        Screen Sharing enables extremely responsive remote
                        access to another Mac so pros can securely work on their
                        highest-quality content from anywhere. Game Mode
                        prioritizes graphics tasks to deliver consistently high
                        frame rates and drastically reduce latency with wireless
                        accessories for even more immersive gameplay with titles
                        like Baldur’s Gate 3, Lies of P, and DEATH STRANDING
                        DIRECTOR’S CUT.
                      </p>
                    </div>
                    <div className="mainimage">
                      <img
                        src="\product\green.svg"
                        alt="img"
                        className="img-fluid innerimg"
                      />
                    </div>
                    <div className="families">
                      <h3 className="mainhead">Better for the Environment</h3>
                      <p className="parazzz">
                        MacBook Pro is built to last. The enclosure is created
                        from a custom alloy that uses 100 percent recycled
                        aluminum and is incredibly durable. MacBook Pro also
                        uses 100 percent recycled rare earth elements in all
                        magnets, and 100 percent recycled tin soldering and gold
                        plating in multiple printed circuit boards. MacBook Pro
                        is also free of numerous harmful substances such as
                        beryllium, brominated flame retardants, and mercury, and
                        100 percent of the wood fiber in the packaging is
                        recycled or comes from responsibly managed forests.
                      </p>
                      <p className="parazzz">
                        Today, Apple is carbon neutral for global corporate
                        operations, and by 2030, plans to be carbon neutral
                        across the entire manufacturing supply chain and all
                        product life cycles. This means that every Apple device
                        sold, from component manufacturing, assembly, transport,
                        customer use, all the way to recycling and material
                        recovery, will be carbon neutral.
                      </p>
                    </div>
                  </div>
                </>
              )}
              {activeTab === "link-2" && (
                <>
                  <div className="rating-parent">
                    <div className="ratingbox">
                      <div className="parenthead">
                        <h6>Product Rating</h6>
                        <div className="bottomparent">
                          <p>
                            4.8{" "}
                            <span>
                              <span className="star">
                                <img
                                  src="\product\starss.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                                (34 Comments)
                              </span>
                            </span>
                          </p>
                          <button className="rate" onClick={handleShow}>
                            Rate Product
                          </button>
                        </div>
                      </div>

                      <div className="cardprogress">
                        <div className="cardprogress">
                          <p className="cardprogresspara">1</p>
                        </div>
                        <ProgressBar now={78} />
                        <div className="cardprogressheadings">
                          <p className="cardprogresspara">78%</p>
                          <h6 className="cardprogresshead">982</h6>
                        </div>
                      </div>
                      <div className="cardprogress">
                        <div className="cardprogress">
                          <p className="cardprogresspara">2</p>
                        </div>
                        <ProgressBar now={40} />
                        <div className="cardprogressheadings">
                          <p className="cardprogresspara">16%</p>
                          <h6 className="cardprogresshead">206</h6>
                        </div>
                      </div>
                      <div className="cardprogress">
                        <div className="cardprogress">
                          <p className="cardprogresspara">3</p>
                        </div>
                        <ProgressBar now={20} />
                        <div className="cardprogressheadings">
                          <p className="cardprogresspara">5%</p>
                          <h6 className="cardprogresshead">982</h6>
                        </div>
                      </div>
                      <div className="cardprogress">
                        <div className="cardprogress">
                          <p className="cardprogresspara">4</p>
                        </div>
                        <ProgressBar now={10} />
                        <div className="cardprogressheadings">
                          <p className="cardprogresspara">1%</p>
                          <h6 className="cardprogresshead">17</h6>
                        </div>
                      </div>
                      <div className="cardprogress">
                        <div className="cardprogress">
                          <p className="cardprogresspara">1</p>
                        </div>
                        <ProgressBar now={5} />
                        <div className="cardprogressheadings">
                          <p className="cardprogresspara">3%</p>
                          <h6 className="cardprogresshead">5</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {activeTab === "link-3" && (
                <>
                  <div className="comments">
                    <div className="commentbox">
                      <h2 className="head">Comments</h2>
                      <div className="maininputssss">
                        <p className="parainput">Heading</p>
                        <input type="text" placeholder="Comment heading" />
                        <p className="parainput">Comment</p>
                        <textarea
                          type="text"
                          placeholder="Write your comment..."
                        />
                      </div>
                      <div className="inputtwo">
                        <div className="leftssss">
                          <p className="parainput">Full Name</p>
                          <input type="text" placeholder="Full name" />
                        </div>
                        <div className="rightsss">
                          <p className="parainput">Email Address</p>
                          <input type="text" placeholder="Email Address" />
                        </div>
                      </div>
                      <button className="submitcomment">Submit Comment</button>
                      <div className="recent">
                        <p>Recent Comments</p>
                        {/* <h6>Sort by:<span> <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
                                                        <path d="M7 1.5L4 4.5L1 1.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg></span></h6> */}
                        <div>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                            >
                              <div className="dropdivv">
                                <p className="sortby">
                                  {" "}
                                  Sort by: <span className="spanpop">Date</span>
                                </p>

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="8"
                                  height="5"
                                  viewBox="0 0 8 5"
                                  fill="none"
                                >
                                  <path
                                    d="M7 1L4 4L1 1"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item href="#/action-1">
                                Date
                              </Dropdown.Item>
                              <Dropdown.Item
                                className="midleassending"
                                href="#/action-2"
                              >
                                {" "}
                                Name: Ascending
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-3">
                                Name: Descending
                              </Dropdown.Item>
                              {/* <Dropdown.Item href="#/action-4">Rating</Dropdown.Item> */}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                      <div className="brdr"></div>
                      <div className="mainnnnnnn">
                        <div className="parentzzzmainnnn">
                          <p>Tina Robinson</p>
                          <h6>19 June 2024</h6>
                        </div>
                        <h4 className="headingzzzz">
                          Sed provident porro vel galisum deserunt
                        </h4>
                        <p className="parazzzz">
                          Ut fugiat aliquam in voluptates doloremque qui nulla
                          culpa sit sequi laudantium et rerum atque et
                          voluptatum fugit ut libero suscipit ea esse laboriosam
                          ex voluptate iusto ut placeat quis et repellat
                          corrupti.
                        </p>
                      </div>
                      <div className="brdr"></div>
                      <div className="mainnnnnnn">
                        <div className="parentzzzmainnnn">
                          <p>Tina Robinson</p>
                          <h6>19 June 2024</h6>
                        </div>
                        <h4 className="headingzzzz">
                          Sed provident porro vel galisum deserunt
                        </h4>
                        <p className="parazzzz">
                          Ut fugiat aliquam in voluptates doloremque qui nulla
                          culpa sit sequi laudantium et rerum atque et
                          voluptatum fugit ut libero suscipit ea esse laboriosam
                          ex voluptate iusto ut placeat quis et repellat
                          corrupti.
                        </p>
                      </div>
                      <div className="brdr"></div>
                      <div className="mainnnnnnn">
                        <div className="parentzzzmainnnn">
                          <p>Tina Robinson</p>
                          <h6>19 June 2024</h6>
                        </div>
                        <h4 className="headingzzzz">
                          Sed provident porro vel galisum deserunt
                        </h4>
                        <p className="parazzzz">
                          Ut fugiat aliquam in voluptates doloremque qui nulla
                          culpa sit sequi laudantium et rerum atque et
                          voluptatum fugit ut libero suscipit ea esse laboriosam
                          ex voluptate iusto ut placeat quis et repellat
                          corrupti.
                        </p>
                      </div>
                      <div>
                        <Pagination>
                          <img
                            className="left"
                            src="\product\Arrow_Right_MD.png"
                            alt="left"
                          />
                          <Pagination.Item active>{1}</Pagination.Item>
                          <Pagination.Item>{2}</Pagination.Item>
                          <Pagination.Item>{3}</Pagination.Item>
                          <Pagination.Item>{4}</Pagination.Item>
                          <Pagination.Item>{5}</Pagination.Item>
                          <Pagination.Ellipsis />
                          <Pagination.Item>{15}</Pagination.Item>
                          <img
                            className="right"
                            src="\product\Arrow_left.png"
                            alt="right"
                          />
                        </Pagination>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Product;
